import { ROLE_V2 } from '@crazygames/graph-types/roles/roles.types';
import React from 'react';

export interface RolesContextType {
  roles: ROLE_V2[];
}

const RolesContext = React.createContext<RolesContextType>({
  roles: [],
});

export default RolesContext;
